import React, { useCallback } from 'react'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import AvatarPicker from './AvatarPicker'

const TemplatePreview = ({ form, template }) => {
  const onSubmit = useCallback(
    (avatar) => {
      if (!avatar || typeof avatar !== 'object') return
      form.setValue('preview', avatar.url)
      // 记录 Preview 对应的 avatar id（仅存到模板数据，用于选择器按 id 查详情）
      form.setValue('previewId', avatar.id || '')
      const isSpine = avatar?.engineWith === 'spine'
      form.setValue('videoPreview', isSpine ? avatar.videoUrl || '' : '')
      form.setValue(
        'videoPreviewPreview',
        isSpine ? avatar.videoPreviewUrl || '' : '',
      )
    },
    [form],
  )

  const preview = form.watch('preview', template.preview)

  return (
    <div className="space-y-2">
      <Label>Preview</Label>
      <p className="text-sm text-muted-foreground">
        从已上传的 Avatar 中选择一个作为 Preview。
      </p>
      <div className="flex gap-2">
        <input
          type="text"
          value={preview || ''}
          readOnly
          placeholder="未选择 Avatar"
          className="flex-1 px-3 py-2 border rounded-md bg-muted/50 text-xs"
        />
        <AvatarPicker template={template} form={form} onSubmit={onSubmit}>
          <Button type="button" variant="outline">
            选择 Preview
          </Button>
        </AvatarPicker>
      </div>
    </div>
  )
}

export default TemplatePreview
